import restful from '../vuex'

const state = {
  ...restful.states('warehouse')
}

const getters = {
  ...restful.getters('warehouse')
}

const actions = {
  ...restful.actions('warehouses')
}

const mutations = {
  ...restful.mutations('warehouse')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
